/**
 * Rsvp or Reservation
 */
export enum SummaryRecordTypeEnum {
  RSVP = <any>'RSVPs',
  RESERVATION = <any>'Reservations',
  ERROR = <any>'error'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/summary-record-type.enum.ts